function EllipsesIcon(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 30 30'
      width='30'
      height='30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <circle cx='6' cy='15.5' r='2.5' fill='currentColor' />
      <circle cx='15' cy='15.5' r='2.5' fill='currentColor' />
      <circle cx='24' cy='15.5' r='2.5' fill='currentColor' />
    </svg>
  )
}

export default EllipsesIcon
